import { tv } from '@pcln/horizon'

export const tripActivityVariants = tv({
  slots: {
    heading: 'mb-4 text-heading3 sm:text-heading2',
    recentSearchesHeading: 'text-heading3',
    similarHotelsHeading: 'text-heading4',
  },
  variants: {
    useSmallerHeading: {
      true: {
        heading: 'text-heading4 sm:text-heading3',
        recentSearchesHeading: 'text-heading4 sm:text-heading3',
        similarHotelsHeading: 'text-heading5 sm:text-heading4',
      },
    },
  },
})
